var React = require('react');

function TagOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z"}));
}

TagOpen.defaultProps = {"height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#e3e3e3"};

module.exports = TagOpen;

TagOpen.default = TagOpen;
